// AUTO-GENERATED by scripts/emit-bundled-contracts.mjs — DO NOT EDIT.
// Source of truth: contracts/**/*.json at the monorepo root.
// Regenerated on every `npm run build`. The public API in
// src/contracts.ts reads from this file.

import type { Contract } from "./contracts";

export const BUNDLED_IN = "@cross-deck/web@1.14.1" as const;
export const SDK_VERSION = "1.14.1" as const;

export const BUNDLED_CONTRACTS: readonly Contract[] = Object.freeze([
  {
    "id": "contract-failed-payload-schema-lock",
    "pillar": "diagnostics",
    "status": "enforced",
    "claim": "The `crossdeck.contract_failed` event payload contains ONLY the named diagnostic fields and never any end-user personal data. The wire shape is fixed — adding a new field requires (1) a pull request that updates this contract's `allowedFields` set, (2) a Privacy Policy §6 amendment, and (3) the Customer Disclosure Template / SDK Data Collection Reference §B updates. Per-SDK assertion tests enforce the field set on every release. The `verification_phase` field is a categorical bucket — values are restricted to `boot` (the SDK self-test ran on Crossdeck.start) or `hot_path` (a verifier observed a real customer-triggered operation). The categorical nature is what preserves the diagnostic-only-not-personal classification. This is the structural guarantee that backs the independent-controller lawful basis in the Privacy Policy: the payload remains diagnostic-only, not personal, so the legitimate-interest analysis stays valid as the SDK evolves.",
    "appliesTo": [
      "web",
      "node",
      "swift",
      "android",
      "react-native"
    ],
    "allowedFields": {
      "required": [
        "contract_id",
        "sdk_version",
        "sdk_platform",
        "failure_reason",
        "run_context",
        "run_id"
      ],
      "optional": [
        "test_file",
        "test_name",
        "device_class",
        "verification_phase"
      ],
      "forbidden": [
        "anonymousId",
        "developerUserId",
        "crossdeckCustomerId",
        "email",
        "ip",
        "user_agent",
        "message",
        "stack",
        "stack_trace",
        "frames",
        "exception_message",
        "url",
        "path",
        "screen",
        "title",
        "label",
        "text",
        "ariaLabel",
        "accessibilityLabel",
        "contentDescription",
        "session_id",
        "sessionId"
      ]
    },
    "transport": "Telemetry is single-fire to the Crossdeck reliability endpoint only — NOT the customer's appId. The customer's track() pipeline never carries `crossdeck.*` events; the customer's dashboard never shows individual contract failures. Operational telemetry flows one-way to the Crossdeck operations team for SDK reliability purposes (legitimate interest, independent-controller flow per Privacy Policy §6). The reliability endpoint is hardcoded at SDK build time; the publishable key for the reliability project is embedded as a constant and rejects writes that don't match the schema.",
    "codeRef": [
      "sdks/web/src/crossdeck.ts",
      "sdks/node/src/crossdeck-server.ts",
      "sdks/swift/Sources/Crossdeck/Crossdeck.swift",
      "sdks/swift/Sources/Crossdeck/_DiagnosticTelemetry.swift",
      "sdks/android/crossdeck/src/main/kotlin/com/crossdeck/Crossdeck.kt",
      "sdks/android/crossdeck/src/main/kotlin/com/crossdeck/_DiagnosticTelemetry.kt",
      "sdks/react-native/src/crossdeck.ts",
      "backend/src/api/v1-sdk-diagnostic.ts",
      "sdks/web/src/_diagnostic-telemetry.ts",
      "sdks/node/src/_diagnostic-telemetry.ts",
      "sdks/react-native/src/_diagnostic-telemetry.ts"
    ],
    "testRef": [
      {
        "file": "sdks/web/tests/contract-failed-schema-lock.test.ts",
        "name": "reportContractFailure payload conforms to schema-lock"
      },
      {
        "file": "sdks/node/tests/contract-failed-schema-lock.test.ts",
        "name": "reportContractFailure payload conforms to schema-lock"
      },
      {
        "file": "sdks/swift/Tests/CrossdeckTests/ContractFailedSchemaLockTests.swift",
        "name": "test_reportContractFailure_payloadFieldsAreInAllowList"
      },
      {
        "file": "sdks/swift/Tests/CrossdeckTests/ContractFailedSchemaLockTests.swift",
        "name": "test_reportContractFailure_doesNotEnterCustomerTrackPipeline"
      },
      {
        "file": "sdks/android/crossdeck/src/test/kotlin/com/crossdeck/ContractFailedSchemaLockTest.kt",
        "name": "reportContractFailure payload conforms to schema-lock"
      },
      {
        "file": "sdks/android/crossdeck/src/test/kotlin/com/crossdeck/ContractFailedSchemaLockTest.kt",
        "name": "reportContractFailure does not enter customer track pipeline"
      },
      {
        "file": "sdks/react-native/tests/contract-failed-schema-lock.test.ts",
        "name": "reportContractFailure payload conforms to schema-lock"
      },
      {
        "file": "backend/tests/unit/v1-sdk-diagnostic.test.ts",
        "name": "forbidden fields are enumerated in the schema-lock contract"
      },
      {
        "file": "backend/tests/unit/v1-sdk-diagnostic.test.ts",
        "name": "required fields are enumerated in the schema-lock contract"
      },
      {
        "file": "backend/tests/unit/v1-sdk-diagnostic.test.ts",
        "name": "regression guard: never returns a raw IP"
      },
      {
        "file": "backend/tests/unit/v1-sdk-diagnostic.test.ts",
        "name": "verification_phase is in the optional field set"
      }
    ],
    "registeredAt": "2026-05-27",
    "firstRegisteredIn": "Diagnostic telemetry single-fire + schema-lock — independent-controller flow",
    "privacyReferences": [
      "legal/privacy/index.html#sdk-diagnostic",
      "legal/customer-disclosure/index.html#flow-b",
      "legal/security/index.html#diagnostic",
      "legal/sdk-data/index.html#b-diagnostic"
    ],
    "bundledIn": "@cross-deck/web@1.14.1",
    "runtimeVerified": true
  },
  {
    "id": "error-envelope-shape",
    "pillar": "errors",
    "status": "enforced",
    "claim": "Every v1 REST endpoint returns errors in a Stripe-shape envelope: `{ error: { type, code, message, request_id } }` where `type` is one of authentication_error / permission_error / invalid_request_error / rate_limit_error / internal_error (the wire vocabulary in backend/src/api/v1-errors.ts ApiErrorType). HTTP status parity: invalid_request_error → 400, authentication_error → 401, permission_error → 403, rate_limit_error → 429, internal_error → 500. SDK-side clients parse this shape via `crossdeckErrorFromResponse` (Web/Node/RN) / `crossdeckErrorFrom(response:)` (Swift) / `crossdeckErrorFromResponse` (Android) and surface the request_id verbatim so support traces are end-to-end joinable. Firebase callable endpoints (managed-keys / dashboard auth) use the Firebase HttpsError envelope instead — this contract applies to REST /v1/* only.",
    "appliesTo": [
      "web",
      "node",
      "react-native",
      "swift",
      "android",
      "backend"
    ],
    "codeRef": [
      "backend/src/api/v1-errors.ts",
      "sdks/web/src/errors.ts",
      "sdks/node/src/errors.ts",
      "sdks/react-native/src/errors.ts",
      "sdks/swift/Sources/Crossdeck/Errors.swift",
      "sdks/android/crossdeck/src/main/kotlin/com/crossdeck/Errors.kt"
    ],
    "testRef": [
      {
        "file": "sdks/swift/Tests/CrossdeckTests/ErrorsTests.swift",
        "name": "test_errorEnvelope_fallsBackOnGarbageBody"
      },
      {
        "file": "sdks/swift/Tests/CrossdeckTests/ErrorsTests.swift",
        "name": "test_errorEnvelope_reads_XRequestId_fallback"
      },
      {
        "file": "sdks/android/crossdeck/src/test/kotlin/com/crossdeck/ErrorTypeWireVocabTest.kt",
        "name": "backend 500 response parses to INTERNAL_ERROR"
      }
    ],
    "registeredAt": "2026-05-26",
    "firstRegisteredIn": "bank-grade reconciliation v1.4.0 — phase 8 (codifies existing contract)",
    "bundledIn": "@cross-deck/web@1.14.1",
    "runtimeVerified": true
  },
  {
    "id": "flush-interval-parity",
    "pillar": "analytics",
    "status": "enforced",
    "claim": "Every Crossdeck SDK defaults its event-queue flush interval to 2000ms — the Stripe-adjacent industry norm. Pre-v1.4.0 the defaults disagreed (Web/Node 1500ms; RN/Swift/Android 5000ms), so cross-platform funnels saw events landing at different cadences. Per-instance override stays — call sites can still tune it freely.",
    "appliesTo": [
      "web",
      "node",
      "react-native",
      "swift",
      "android"
    ],
    "codeRef": [
      "sdks/web/src/crossdeck.ts",
      "sdks/node/src/crossdeck-server.ts",
      "sdks/react-native/src/crossdeck.ts",
      "sdks/swift/Sources/Crossdeck/EventQueue.swift",
      "sdks/android/crossdeck/src/main/kotlin/com/crossdeck/EventQueue.kt"
    ],
    "testRef": [
      {
        "file": "sdks/swift/Sources/Crossdeck/EventQueue.swift",
        "name": "flushIntervalMs: Int = 2_000"
      },
      {
        "file": "sdks/android/crossdeck/src/main/kotlin/com/crossdeck/EventQueue.kt",
        "name": "flushIntervalMs: Long = 2_000L"
      },
      {
        "file": "sdks/web/src/crossdeck.ts",
        "name": "options.eventFlushIntervalMs ?? 2000"
      },
      {
        "file": "sdks/node/src/crossdeck-server.ts",
        "name": "options.eventFlushIntervalMs ?? 2000"
      },
      {
        "file": "sdks/react-native/src/crossdeck.ts",
        "name": "options.eventFlushIntervalMs ?? 2000"
      }
    ],
    "registeredAt": "2026-05-26",
    "firstRegisteredIn": "bank-grade reconciliation v1.4.0 — phase 3.3",
    "bundledIn": "@cross-deck/web@1.14.1",
    "runtimeVerified": true
  },
  {
    "id": "idempotency-key-deterministic",
    "pillar": "revenue",
    "status": "enforced",
    "claim": "syncPurchases() on every SDK derives a deterministic Idempotency-Key from the request body (UUID-shaped SHA-256 of `crossdeck:purchases/sync:<rail>:<jws|token>`). Same input -> same key. Backend short-circuits same-key-same-body retries by returning the cached response (status + body) with `idempotent_replay: true` flag in the body AND `Idempotent-Replayed: true` response header. Same-key-different-body returns 400 `idempotency_key_in_use`. 24-hour TTL matches Stripe. Cache only stores 2xx responses — 4xx/5xx pass through so callers can fix bugs and retry. Helper returns nil/throws on missing identifier (no silent random fallback). Cross-SDK parity is CI-pinned: deriveForPurchase('apple', 'eyJ.jws.sig') MUST equal 'a66b1640-efaf-bb4d-1261-6650033bf111' on every SDK.",
    "appliesTo": [
      "web",
      "node",
      "react-native",
      "swift",
      "android",
      "backend"
    ],
    "codeRef": [
      "sdks/web/src/idempotency-key.ts",
      "sdks/web/src/crossdeck.ts",
      "sdks/react-native/src/idempotency-key.ts",
      "sdks/react-native/src/crossdeck.ts",
      "sdks/node/src/idempotency-key.ts",
      "sdks/node/src/crossdeck-server.ts",
      "sdks/swift/Sources/Crossdeck/IdempotencyKey.swift",
      "sdks/swift/Sources/Crossdeck/Crossdeck.swift",
      "sdks/android/crossdeck/src/main/kotlin/com/crossdeck/IdempotencyKey.kt",
      "sdks/android/crossdeck/src/main/kotlin/com/crossdeck/Crossdeck.kt",
      "backend/src/lib/idempotency-response-cache.ts",
      "backend/src/api/v1-purchases.ts"
    ],
    "testRef": [
      {
        "file": "sdks/web/tests/idempotency-key.test.ts",
        "name": "cross-SDK oracle — apple JWS pins canonical vector"
      },
      {
        "file": "sdks/web/tests/idempotency-key.test.ts",
        "name": "is deterministic: same body twice -> identical key"
      },
      {
        "file": "sdks/web/tests/idempotency-key.test.ts",
        "name": "same identifier under different rails -> different keys"
      },
      {
        "file": "sdks/web/tests/idempotency-key.test.ts",
        "name": "never silently falls back to a random key on missing identifier"
      },
      {
        "file": "sdks/react-native/tests/idempotency-key.test.ts",
        "name": "is deterministic"
      },
      {
        "file": "sdks/react-native/tests/idempotency-key.test.ts",
        "name": "cross-SDK oracle — apple JWS pins canonical vector"
      },
      {
        "file": "sdks/node/tests/idempotency-key.test.ts",
        "name": "is deterministic"
      },
      {
        "file": "sdks/node/tests/idempotency-key.test.ts",
        "name": "rail namespacing prevents cross-rail collisions"
      },
      {
        "file": "sdks/node/tests/idempotency-key.test.ts",
        "name": "apple JWS produces the canonical pinned UUID across all 5 SDKs"
      },
      {
        "file": "backend/tests/unit/idempotency-response-cache.test.ts",
        "name": "is deterministic for the same input"
      },
      {
        "file": "backend/tests/unit/idempotency-response-cache.test.ts",
        "name": "injects idempotent_replay: true into a JSON object body"
      },
      {
        "file": "backend/tests/unit/idempotency-response-cache.test.ts",
        "name": "matches Stripe's 24-hour idempotency window"
      },
      {
        "file": "sdks/swift/Tests/CrossdeckTests/IdempotencyKeyTests.swift",
        "name": "test_crossSdkOracle_appleJWS"
      },
      {
        "file": "sdks/swift/Tests/CrossdeckTests/IdempotencyKeyTests.swift",
        "name": "test_railNamespacing_preventsCrossRailCollisions"
      },
      {
        "file": "sdks/swift/Tests/CrossdeckTests/IdempotencyKeyTests.swift",
        "name": "test_missingIdentifier_returnsNil"
      },
      {
        "file": "sdks/android/crossdeck/src/test/kotlin/com/crossdeck/IdempotencyKeyTest.kt",
        "name": "cross-SDK oracle for apple JWS"
      },
      {
        "file": "sdks/android/crossdeck/src/test/kotlin/com/crossdeck/IdempotencyKeyTest.kt",
        "name": "rail namespacing prevents cross-rail collisions"
      },
      {
        "file": "sdks/android/crossdeck/src/test/kotlin/com/crossdeck/IdempotencyKeyTest.kt",
        "name": "missing identifier returns null - never silent random fallback"
      }
    ],
    "registeredAt": "2026-05-26",
    "firstRegisteredIn": "bank-grade reconciliation v1.4.0 — phase 2.2.a + 2.2.b + 2.2.c",
    "bundledIn": "@cross-deck/web@1.14.1",
    "runtimeVerified": true
  },
  {
    "id": "init-reentry-drains-prior-queue",
    "pillar": "lifecycle",
    "status": "enforced",
    "claim": "Web + RN init() re-entry drains the prior EventQueue's pending setTimeout BEFORE replacing this.state. Pre-v1.4.0 the teardown handled autoTracker/webVitals/errors/unloadFlush but NOT events, so the prior queue's timer would fire AFTER the state swap — sending old-init events against new-init http + identity references (cross-identity leak during HMR / config swap / multi-tenant SDK shells). The teardown CANNOT call persistent.clear() — the durable queue belongs to the SDK lifetime, not the init() lifetime, and a survived crash mid-flush re-hydrates on the next init.",
    "appliesTo": [
      "web",
      "react-native"
    ],
    "codeRef": [
      "sdks/web/src/crossdeck.ts",
      "sdks/react-native/src/crossdeck.ts"
    ],
    "testRef": [
      {
        "file": "sdks/web/tests/init-reentry.test.ts",
        "name": "re-init drains the prior queue's pending timer before swapping state"
      },
      {
        "file": "sdks/web/tests/init-reentry.test.ts",
        "name": "re-init does NOT wipe the durable event store"
      }
    ],
    "registeredAt": "2026-05-26",
    "firstRegisteredIn": "bank-grade reconciliation v1.4.0 — phase 5.5",
    "bundledIn": "@cross-deck/web@1.14.1",
    "runtimeVerified": false
  },
  {
    "id": "invalid-input-rejected-natively",
    "pillar": "errors",
    "status": "enforced",
    "claim": "No public SDK API ever crashes the host app, and invalid input never reaches the wire. Invalid input (empty event name, empty userId, out-of-range config such as a non-positive breadcrumb capacity, NaN/Infinity/oversize/cyclic property values) is rejected at the call site WITHOUT a fatal trap. The signalling IDIOM is per-language and intentionally NOT uniform: Web, Node, and React Native THROW a typed CrossdeckError synchronously (code missing_event_name / missing_user_id / invalid_request_error) — a normal, catchable JavaScript convention where an uncaught throw logs and the app continues; Swift DROPS with a debug-log signal (track_dropped / identify_dropped) to match its non-throwing fire-and-forget surface, and exposes the throwing equivalent only via identifyAndWait(userId:). What is UNIFORM is the invariant, not the mechanism: every SDK rejects the same inputs, no public fire-and-forget API contains a fatalError / assertionFailure / precondition reachable from customer input, and no rejected input is enqueued or transmitted. Swift additionally proves this in BOTH debug and release configuration, because precondition fires under -O while assertionFailure does not. The bug class this contract closes was never the per-language difference — it was the UNDECLARED difference: each SDK's public API documentation must state its own semantics explicitly (TS docs: 'throws on empty name'; Swift docs: 'drops and logs').",
    "appliesTo": [
      "web",
      "node",
      "react-native",
      "swift"
    ],
    "codeRef": [
      "sdks/web/src/crossdeck.ts",
      "sdks/node/src/crossdeck-server.ts",
      "sdks/react-native/src/crossdeck.ts",
      "sdks/swift/Sources/Crossdeck/Crossdeck.swift",
      "sdks/swift/Sources/Crossdeck/Breadcrumbs.swift"
    ],
    "testRef": [
      {
        "file": "sdks/web/tests/crossdeck.test.ts",
        "name": "track with empty name throws synchronously"
      },
      {
        "file": "sdks/web/tests/crossdeck.test.ts",
        "name": "rejects empty userId"
      },
      {
        "file": "sdks/node/tests/crossdeck-server.test.ts",
        "name": "track() throws CrossdeckError with code 'missing_event_name' when event name is empty"
      },
      {
        "file": "sdks/react-native/tests/crossdeck.test.ts",
        "name": "track('') throws CrossdeckError(missing_event_name) synchronously"
      },
      {
        "file": "sdks/react-native/tests/crossdeck.test.ts",
        "name": "identify('') rejects with CrossdeckError(missing_user_id)"
      },
      {
        "file": "sdks/swift/Tests/CrossdeckTests/CrossdeckPublicAPITests.swift",
        "name": "test_track_dropsEmptyName"
      },
      {
        "file": "sdks/swift/Tests/CrossdeckTests/CrossdeckPublicAPITests.swift",
        "name": "test_identifyAndWait_rejectsEmptyId"
      },
      {
        "file": "sdks/swift/Tests/CrossdeckTests/PublicAPIInputSafetyTests.swift",
        "name": "test_start_withZeroBreadcrumbCapacity_doesNotTrap"
      }
    ],
    "registeredAt": "2026-06-11",
    "firstRegisteredIn": "swift trap-on-input class fix — first machine-tested Swift release",
    "bundledIn": "@cross-deck/web@1.14.1",
    "runtimeVerified": false
  },
  {
    "id": "per-user-cache-isolation",
    "pillar": "entitlements",
    "status": "enforced",
    "claim": "Every identify(userId) switches the entitlement cache to a physically separate per-user storage slot — `crossdeck:entitlements:<sha256(userId)>` — and unconditionally wipes the in-memory snapshot. A user-switch on a shared device CANNOT cross-read a prior user's cached entitlements, even if the in-memory clear is somehow skipped, because the storage keys are physically separate. reset() wipes every per-user slot via the persisted index.",
    "appliesTo": [
      "web",
      "react-native",
      "swift",
      "android"
    ],
    "codeRef": [
      "sdks/web/src/entitlement-cache.ts",
      "sdks/web/src/hash.ts",
      "sdks/web/src/crossdeck.ts",
      "sdks/react-native/src/entitlement-cache.ts",
      "sdks/react-native/src/hash.ts",
      "sdks/react-native/src/crossdeck.ts",
      "sdks/swift/Sources/Crossdeck/EntitlementCache.swift",
      "sdks/swift/Sources/Crossdeck/IdempotencyKey.swift",
      "sdks/swift/Sources/Crossdeck/Crossdeck.swift",
      "sdks/android/crossdeck/src/main/kotlin/com/crossdeck/EntitlementCache.kt",
      "sdks/android/crossdeck/src/main/kotlin/com/crossdeck/IdempotencyKey.kt",
      "sdks/android/crossdeck/src/main/kotlin/com/crossdeck/Crossdeck.kt"
    ],
    "testRef": [
      {
        "file": "sdks/web/tests/entitlement-cache-isolation.test.ts",
        "name": "identify(B) makes A's entitlements unreachable from in-memory"
      },
      {
        "file": "sdks/web/tests/entitlement-cache-isolation.test.ts",
        "name": "clearAll() removes every per-user storage key plus the index"
      },
      {
        "file": "sdks/web/tests/entitlement-cache-isolation.test.ts",
        "name": "a second cache instance reading A's storage suffix CANNOT see B's data"
      },
      {
        "file": "sdks/react-native/tests/entitlement-cache-isolation.test.ts",
        "name": "identify(B) makes A's entitlements unreachable from in-memory"
      },
      {
        "file": "sdks/react-native/tests/entitlement-cache-isolation.test.ts",
        "name": "removes every per-user storage key plus the index"
      },
      {
        "file": "sdks/swift/Tests/CrossdeckTests/EntitlementCacheIsolationTests.swift",
        "name": "test_identifyB_makesAEntitlementsUnreachable"
      },
      {
        "file": "sdks/swift/Tests/CrossdeckTests/EntitlementCacheIsolationTests.swift",
        "name": "test_identifiedWritesLandUnderPerUserSha256Key"
      },
      {
        "file": "sdks/swift/Tests/CrossdeckTests/EntitlementCacheIsolationTests.swift",
        "name": "test_clearAll_removesEveryPerUserStorageKeyPlusIndex"
      },
      {
        "file": "sdks/android/crossdeck/src/test/kotlin/com/crossdeck/EntitlementCacheIsolationTest.kt",
        "name": "identified writes land under per-user sha256 key"
      },
      {
        "file": "sdks/android/crossdeck/src/test/kotlin/com/crossdeck/EntitlementCacheIsolationTest.kt",
        "name": "identify B makes A entitlements unreachable from in-memory"
      },
      {
        "file": "sdks/android/crossdeck/src/test/kotlin/com/crossdeck/EntitlementCacheIsolationTest.kt",
        "name": "clearAll removes every per-user storage key plus the index"
      },
      {
        "file": "sdks/android/crossdeck/src/test/kotlin/com/crossdeck/EntitlementCacheIsolationTest.kt",
        "name": "a fresh cache bound to A's key CANNOT read B's blob"
      }
    ],
    "registeredAt": "2026-05-26",
    "firstRegisteredIn": "bank-grade reconciliation v1.4.0 — phase 1.3 (web/RN) + dogfood-gap fix (swift + android)",
    "bundledIn": "@cross-deck/web@1.14.1",
    "runtimeVerified": true
  },
  {
    "id": "sdk-error-codes-catalogue",
    "pillar": "errors",
    "status": "enforced",
    "claim": "Web + Node SDK error-codes catalogues include EVERY backend-emitted ApiErrorCode with a description + resolution. Pre-v1.4.0 the catalogues documented codes the SDK threw ITSELF but ZERO backend codes — a developer hitting `invalid_api_key` / `origin_not_allowed` / `bundle_id_not_allowed` / `env_mismatch` / `idempotency_key_in_use` etc. got `undefined` from getErrorCode() and had to hunt for guidance. v1.4.0 backfills the catalogue from backend/src/api/v1-errors.ts so every wire code has a canonical 'what does this mean / what should I do' answer Stripe-style.",
    "appliesTo": [
      "web",
      "node"
    ],
    "codeRef": [
      "sdks/web/src/error-codes.ts",
      "sdks/node/src/error-codes.ts",
      "sdks/web/src/_contract-verifiers.ts",
      "backend/src/api/v1-errors.ts"
    ],
    "testRef": [
      {
        "file": "sdks/web/tests/contract-verifiers.test.ts",
        "name": "sdk-error-codes-catalogue covers every backend wire code with remediation"
      },
      {
        "file": "sdks/web/tests/error-codes-backfill.test.ts",
        "name": "includes backend code"
      },
      {
        "file": "sdks/web/tests/error-codes-backfill.test.ts",
        "name": "invalid_api_key resolution points at the dashboard"
      },
      {
        "file": "sdks/web/tests/error-codes-backfill.test.ts",
        "name": "idempotency_key_in_use resolution mentions Stripe-grade contract"
      },
      {
        "file": "sdks/web/tests/error-codes-backfill.test.ts",
        "name": "identity-lock codes carry permission_error type"
      },
      {
        "file": "sdks/web/tests/error-codes-backfill.test.ts",
        "name": "no entry has an empty description or resolution"
      }
    ],
    "registeredAt": "2026-05-26",
    "firstRegisteredIn": "bank-grade reconciliation v1.4.0 — phase 6.2",
    "bundledIn": "@cross-deck/web@1.14.1",
    "runtimeVerified": true
  },
  {
    "id": "super-property-merge-precedence",
    "pillar": "analytics",
    "status": "enforced",
    "claim": "Every Crossdeck SDK merges event properties with the precedence device < super < caller (caller-supplied values win over registered super-properties, which win over auto-attached device info). Pre-v1.4.0 Swift had it INVERTED (super < device < caller — device clobbered super), so a `register('plan', 'pro')` super-property was silently overridden by auto-attached device fields whenever keys collided. Cross-SDK funnel queries on super-property keys returned different answers per platform.",
    "appliesTo": [
      "web",
      "swift"
    ],
    "codeRef": [
      "sdks/web/src/super-properties.ts",
      "sdks/web/src/_contract-verifiers.ts",
      "sdks/swift/Sources/Crossdeck/EventPropertyMerge.swift",
      "sdks/swift/Sources/Crossdeck/Crossdeck.swift"
    ],
    "testRef": [
      {
        "file": "sdks/web/tests/contract-verifiers.test.ts",
        "name": "super-property-merge-precedence verifies caller > super > device"
      },
      {
        "file": "sdks/swift/Tests/CrossdeckTests/EventPropertyMergeTests.swift",
        "name": "test_super_overrides_device"
      },
      {
        "file": "sdks/swift/Tests/CrossdeckTests/EventPropertyMergeTests.swift",
        "name": "test_caller_overrides_super"
      },
      {
        "file": "sdks/swift/Tests/CrossdeckTests/EventPropertyMergeTests.swift",
        "name": "test_full_precedence_chain"
      },
      {
        "file": "sdks/swift/Tests/CrossdeckTests/EventPropertyMergeTests.swift",
        "name": "test_matchesWebNodeRNPrecedence"
      }
    ],
    "registeredAt": "2026-05-26",
    "firstRegisteredIn": "bank-grade reconciliation v1.4.0 — phase 3.2",
    "bundledIn": "@cross-deck/web@1.14.1",
    "runtimeVerified": true
  },
  {
    "id": "sync-purchases-funnel-parity",
    "pillar": "analytics",
    "status": "enforced",
    "claim": "Manual syncPurchases() emits a `purchase.completed` analytics event on success across ALL SDKs (Web / Node / RN / Swift / Android). Pre-v1.4.0 only Swift/Android auto-track emitted it — Web/Node/RN manual calls + Swift/Android manual calls fired ZERO analytics. Schema mirrors the auto-track event name + rail/productId/subscriptionId so cross-platform funnels reconcile on every payment path. When the backend short-circuits via the v1.4.0 idempotency cache, the event also carries `idempotent_replay: true`.",
    "appliesTo": [
      "web",
      "node",
      "react-native",
      "swift",
      "android"
    ],
    "codeRef": [
      "sdks/web/src/crossdeck.ts",
      "sdks/node/src/crossdeck-server.ts",
      "sdks/react-native/src/crossdeck.ts",
      "sdks/swift/Sources/Crossdeck/Crossdeck.swift",
      "sdks/android/crossdeck/src/main/kotlin/com/crossdeck/Crossdeck.kt"
    ],
    "testRef": [
      {
        "file": "sdks/web/tests/sync-purchases-funnel.test.ts",
        "name": "emits purchase.completed after a successful sync"
      },
      {
        "file": "sdks/web/tests/sync-purchases-funnel.test.ts",
        "name": "carries idempotent_replay=true when backend replied from cache"
      }
    ],
    "registeredAt": "2026-05-26",
    "firstRegisteredIn": "bank-grade reconciliation v1.4.0 — phase 3.5",
    "bundledIn": "@cross-deck/web@1.14.1",
    "runtimeVerified": false
  }
]) as readonly Contract[];
